import { partfinitiClient } from 'core/services/partfinitiClient';
import { getQueryStringToSnakeCase, objectKeysSnakeCaseToCamelCase } from 'core/utils';
import {
  IBellNotificationsRequestPayload,
  IBellNotificationsResponse,
  IBellNotificationsUnreadSummary,
  IBellNotificationWriteResponse,
} from 'notifications/types';

const NOTIFICATIONS_PATH = '/api/notifications';

export const getNotifications = async (
  requestPayload: IBellNotificationsRequestPayload
): Promise<IBellNotificationsResponse> => {
  const { data } = await partfinitiClient.get(
    `${NOTIFICATIONS_PATH}?${getQueryStringToSnakeCase(requestPayload)}`
  );

  return objectKeysSnakeCaseToCamelCase(data) as IBellNotificationsResponse;
};

export const getUnreadSummary = async (): Promise<IBellNotificationsUnreadSummary> => {
  const { data } = await partfinitiClient.get(`${NOTIFICATIONS_PATH}/unread-count`);

  return objectKeysSnakeCaseToCamelCase(data) as IBellNotificationsUnreadSummary;
};

// The BE reads `id` from $_POST: a JSON body (postJson) is not parsed and answers 400.
export const markAsRead = (id: number): Promise<IBellNotificationWriteResponse> =>
  partfinitiClient.postForm(`${NOTIFICATIONS_PATH}/read`, { id });

export const markAsUnread = (id: number): Promise<IBellNotificationWriteResponse> =>
  partfinitiClient.postForm(`${NOTIFICATIONS_PATH}/unread`, { id });

// `maxId` (max_id on the wire) bounds both "all" writes to what the user was shown: without it
// the BE also takes a notification created since the last refresh.
export const markAllAsRead = (maxId: number): Promise<IBellNotificationWriteResponse> =>
  partfinitiClient.postForm(`${NOTIFICATIONS_PATH}/read-all`, { maxId });

export const dismiss = (id: number): Promise<IBellNotificationWriteResponse> =>
  partfinitiClient.postForm(`${NOTIFICATIONS_PATH}/dismiss`, { id });

export const dismissAll = (maxId: number): Promise<IBellNotificationWriteResponse> =>
  partfinitiClient.postForm(`${NOTIFICATIONS_PATH}/dismiss-all`, { maxId });
